import { render, staticRenderFns } from "./ListarCartorios.vue?vue&type=template&id=2a9b6352"
import script from "./ListarCartorios.vue?vue&type=script&lang=js"
export * from "./ListarCartorios.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports